
const columnise = (array, width) => (array || []).reduce((memo, item, i) => {
  if (i % width === 0) {
    memo.push([]);
  }
  memo[memo.length - 1].push(item);
  return memo;
}, []);

export default columnise;
